/**
 * The mark of the recommended Subscribe & Save frequency. This file imports nothing, so the operator apps load it through
 * the `@brandclub/common-ui/BrandclubLanding/BrandclubCheckout/recommendedMark` sub-export without the common-ui tree.
 */

/** The text of a frequency option, with " (recommended)" after the recommended option. */
export const withRecommendedMark = (text: string, option: { recommended?: boolean }) =>
  option.recommended ? `${text} (recommended)` : text;
